import { useState } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from './ui/dialog';

export const SurahModal = ({ 
  isOpen, 
  onClose, 
  onSave, 
  surah = null,
  isLoading = false 
}) => {
  const { t } = useLanguage();
  const isEdit = !!surah;

  const [formData, setFormData] = useState({
    number: surah?.number || '',
    name_arabic: surah?.name_arabic || '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      ...formData,
      number: parseInt(formData.number, 10),
      name_french: formData.name_arabic,
    });
  };

  const handleChange = (field) => (e) => {
    setFormData(prev => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]" data-testid="surah-modal">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl">
            {isEdit ? t('editSurah') : t('addSurah')}
          </DialogTitle>
        </DialogHeader>

        <motion.form 
          onSubmit={handleSubmit}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="space-y-6 py-4"
        >
          {/* Surah Number */}
          <div className="space-y-2">
            <Label htmlFor="number">{t('surahNumber')}</Label>
            <Input
              id="number"
              type="number"
              min="1"
              max="114"
              value={formData.number}
              onChange={handleChange('number')}
              placeholder="1-114"
              required
              className="rounded-xl"
              data-testid="surah-number-input"
            />
          </div>

          {/* Arabic Name */}
          <div className="space-y-2">
            <Label htmlFor="name_arabic">{t('surahNameArabic')}</Label>
            <Input
              id="name_arabic"
              type="text"
              value={formData.name_arabic}
              onChange={handleChange('name_arabic')}
              placeholder="الفاتحة"
              required
              className="rounded-xl font-arabic text-right text-lg"
              dir="rtl"
              data-testid="surah-arabic-input"
            />
          </div>

          <DialogFooter className="gap-2">
            <Button 
              type="button" 
              variant="outline" 
              onClick={onClose}
              className="rounded-full"
              data-testid="surah-cancel-btn"
            >
              {t('cancel')}
            </Button>
            <Button 
              type="submit" 
              disabled={isLoading}
              className="rounded-full bg-primary hover:bg-primary/90"
              data-testid="surah-save-btn"
            >
              {isLoading ? t('loading') : t('save')}
            </Button>
          </DialogFooter>
        </motion.form>
      </DialogContent>
    </Dialog>
  );
};
